import React, { useEffect } from 'react';

import ErrorBoundary from './components/ErrorHandling/ErrorBoundary';
import ErrorFallback from './components/ErrorHandling/ErrorFallback';
import { PrimeReactProvider } from 'primereact/api';
import { BrowserRouter as Router } from 'react-router-dom';
import ActionActivityCenter from './components/ActionActivityCenter/ActionActivityCenter';
import Routes from './routes/Routes';
import SimpleLoader from './components/common/SimpleLoader';
import WebSocketListener from './services/WebSocketListener';
import ConditionalAuthProvider from './components/ConditionalAuthProvider';

import { FEATURE_FLAGS } from './config/featureFlags';
import { injectThemeTokens } from './config/themeTokens';
import { currentTheme as theme } from './config/themeConfig';

// theme provided by config/themeConfig as single source of truth

const App: React.FC = () => {
  useEffect(() => {
    injectThemeTokens();

    // Update favicon and apple-touch-icon
    const favicon = document.getElementById('favicon') as HTMLLinkElement;
    const appleIcon = document.getElementById('apple-icon') as HTMLLinkElement;
    const pageTitle = document.getElementById('page-title') as HTMLTitleElement;
    
    if (favicon) favicon.href = theme.icon;
    if (appleIcon) appleIcon.href = theme.logo;
    if (pageTitle) pageTitle.textContent = theme.title;

    // Update theme color
    const themeColorMeta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement;
    if (themeColorMeta) themeColorMeta.content = theme.color;

    // Apply Univers font family to document
    document.documentElement.style.setProperty('--font-family', theme.fontFamily);
    document.body.style.fontFamily = theme.fontFamily;
  }, []);

const Loading = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <div > <SimpleLoader/></div> {/* Replace with your loader component or styling */}
  </div>
);



  return (
    // <div >

      <ConditionalAuthProvider LoadingComponent={<Loading />}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <PrimeReactProvider>
            <Router>
              <Routes/>
              {FEATURE_FLAGS.actionsTracking ? <ActionActivityCenter /> : null}
            </Router>
            {/* ----- WEBSOCKET TESTER CARD ----- */}
            {/* <div className="grid custom-grid-col" style={{ marginTop: "2rem", paddingLeft: "70px" }} >
              <div className="col-12 sm:col-12 md:col-6 lg:col-4 xl:col-4">
                <Card className="dashboard-card" title="WebSocket Tester">
                  <WebSocketTester />
                </Card>
              </div>
            </div> */}

            {/* ----- WEBSOCKET TestBroadcast Button CARD ----- */}
            {/* <div className="grid custom-grid-col" style={{ marginTop: "2rem", paddingLeft: "70px" }} >
              <div className="col-12 sm:col-12 md:col-6 lg:col-4 xl:col-4">
                <Card className="dashboard-card" title="WebSocket Tester">
                  <BroadcastTester/>
                </Card>
              </div>
            </div> */}
          </PrimeReactProvider>
          <WebSocketListener/>
        </ErrorBoundary>
      </ConditionalAuthProvider>

    // </div>
  );
};

export default App;
